import styled, { css } from 'styled-components';
import { px2rem } from '../utils/helpers/style.js';
import { styles } from '../constants/styles.js';
import { boxStyles } from '../Box/styles.js';
import { boxPropExclusions } from '../Box/props.js';

var justifyContent = function justifyContent(size) {
  return function (props) {
    var alignment = props[size];
    if (!alignment) return null;
    return css(["justify-content:", ";"], alignment === 'start' ? 'flex-start' : alignment === 'end' ? 'flex-end' : alignment);
  };
};
var rowAlignmentExclusions = new Set(['alignXxs', 'alignXs', 'alignS', 'alignM', 'alignL', 'alignXl', 'alignXxl']);
var row = /*#__PURE__*/styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !(boxPropExclusions.has(prop) || rowAlignmentExclusions.has(prop));
  }
}).withConfig({
  displayName: "styles__row",
  componentId: "sc-143t379-0"
})(["display:flex;box-sizing:border-box;flex-direction:row;flex-wrap:wrap;margin-left:", ";margin-right:", ";text-align:inherit;", " ", "{margin-left:", ";margin-right:", ";", "}", "{margin-left:", ";margin-right:", ";", "}", "{margin-left:", ";margin-right:", ";", "}", "{margin-left:", ";margin-right:", ";", "}", "{margin-left:", ";margin-right:", ";", "}", "{margin-left:", ";margin-right:", ";", "}", ";"], px2rem(-6), px2rem(-6), justifyContent('alignXxs'), styles.breakpoint.xs, px2rem(-6), px2rem(-6), justifyContent('alignXs'), styles.breakpoint.s, px2rem(-8), px2rem(-8), justifyContent('alignS'), styles.breakpoint.m, px2rem(-8), px2rem(-8), justifyContent('alignM'), styles.breakpoint.l, px2rem(-12), px2rem(-12), justifyContent('alignL'), styles.breakpoint.xl, px2rem(-12), px2rem(-12), justifyContent('alignXl'), styles.breakpoint.xxl, px2rem(-12), px2rem(-12), justifyContent('alignXxl'), boxStyles);

export { row };
